import React, { Fragment } from 'react';
import * as ScheduleHistoryUI from './ScheduleHistoryUI';
import { Carousel } from 'react-responsive-carousel';
import { Modal as SemanticModal } from 'semantic-ui-react';
import { batch } from 'react-redux';
import {
  clearHistoryAction,
  loadScreenshotAction,
  selectScreenshotAction,
  toggleScreenshotModalAction,
} from '../../../../redux/actions/scheduler';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { assertCondition, assertNotNil } from '../../../../utils/types';
import { globalFormat } from '../../../../utils/formatting';
import { getFloatingHostElement } from '../../../../components/FloatingManager';

export default () => {
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();
  const dispatch = useAppDispatch();
  const scheduleHistory = useAppSelector(
    (state) => state.scheduler.currentHistory,
  );

  const isScreenshotModalOpen = useAppSelector(
    (state) => state.scheduler.isScreenshotModalOpen,
  );
  const screenshotSelectedImage = useAppSelector(
    (state) => state.scheduler.screenshotSelectedImage,
  );
  const loadedScreenshots = useAppSelector(
    (state) => state.scheduler.loadedScreenshots,
  );
  assertNotNil(screenshotSelectedImage);
  // Show a placeholder if the image is not loaded
  const loadCarouselImage = (screenshotUrl: string) =>
    dispatch(loadScreenshotAction(screenshotUrl));

  const closeScreenshot = () =>
    batch(() => {
      dispatch(toggleScreenshotModalAction(false));
      dispatch(selectScreenshotAction(null));
      // XXX also clear the history in the dropdown on modal close
      dispatch(clearHistoryAction());
    });

  return (
    <SemanticModal
      open={isScreenshotModalOpen}
      onClose={closeScreenshot}
      closeIcon={<ScheduleHistoryUI.ModalCloseIcon name="close" />}
      mountNode={getFloatingHostElement()}
    >
      <ScheduleHistoryUI.CarouselOuterContainer>
        <Carousel
          selectedItem={screenshotSelectedImage}
          showThumbs={false}
          showIndicators={false}
          showStatus={false}
        >
          {scheduleHistory
            ?.filter((historyRecord) => {
              if (!historyRecord) {
                return false;
              }
              assertCondition(historyRecord.__typename === 'AnalysesRun');
              return !!historyRecord.screenshotUrl;
            })
            .map((historyRecord) => {
              assertCondition(
                historyRecord && historyRecord.__typename === 'AnalysesRun',
              );
              const {
                schedule: { name: scheduleName },
                runAt,
                screenshotUrl,
              } = historyRecord;
              assertNotNil(screenshotUrl);
              return (
                <Fragment key={screenshotUrl}>
                  <ScheduleHistoryUI.CarouselTitleWrapper>
                    <ScheduleHistoryUI.CarouselDate>
                      {globalFormat.formatDate(runAt, {
                        dateFormat,
                        timeFormat,
                      })}
                    </ScheduleHistoryUI.CarouselDate>
                    <ScheduleHistoryUI.CarouselTitle>
                      {scheduleName}
                    </ScheduleHistoryUI.CarouselTitle>
                  </ScheduleHistoryUI.CarouselTitleWrapper>
                  <ScheduleHistoryUI.CarouselImageWrapper>
                    {!loadedScreenshots?.[screenshotUrl] && (
                      <ScheduleHistoryUI.StyledPlaceholder>
                        <ScheduleHistoryUI.StyledPlaceholderImage rectangular />
                      </ScheduleHistoryUI.StyledPlaceholder>
                    )}
                    <ScheduleHistoryUI.Image
                      src={screenshotUrl}
                      alt="Record Screenshot"
                      onLoad={() => loadCarouselImage(screenshotUrl)}
                      fluid
                      style={{
                        borderRadius: '4px',
                      }}
                    />
                  </ScheduleHistoryUI.CarouselImageWrapper>
                </Fragment>
              );
            })}
        </Carousel>
      </ScheduleHistoryUI.CarouselOuterContainer>
    </SemanticModal>
  );
};
